import Vue from "vue";
import Vuex from "vuex";

import api from "./utils/api";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    config: {},
    store: {},
    moneyFormat: "",
    shopifyPlan: "",
    appBridgeApp: null,
    navLinks: [],
    googleAccount: { isGoogleConnected: false }
  },
  modules: {
    // Inbox,
  },
  mutations: {
    SET_CONFIG: (state, payload) => {
      state.config = payload;
    },

    SET_STORE: (state, payload) => {
      state.store = payload;
    },
    SET_SHOPIFY_PLAN: (state, payload) => {
      state.shopifyPlan = payload;
    },
    SET_GOOGLE_ACCOUNT: (state, payload) => {
      state.googleAccount = payload;
    },

    updateConfig: (state, payload) => {
      Vue.set(state.config, payload.key, payload.value);
    },

    SET_APP_BRIDGE_APP(state, payload) {
      state.appBridgeApp = payload;
    },
    UPDATE_NAV_LINKS(state, payload) {
      state.navLinks = payload;
    }
  },
  getters: {
    getConfig: state => state.config,
    getStore: state => state.store,
    getShopifyPlan: state => state.shopifyPlan,
    getAppBridgeApp: state => state.appBridgeApp,
    getGoogleAccount: state => state.googleAccount,
    getNavLinks: state => state.navLinks
  },
  actions: {
    getConfig(context) {
      return api.get(`shopify/config`).then(response => {
        context.commit("SET_CONFIG", response.config);

        context.commit("SET_STORE", response.store);
        context.commit("SET_SHOPIFY_PLAN", response.shopifyPlan);
        return response;
      });
    },
    updateConfig(context, payload) {
      return api.put(`shopify/config`, payload.requestParams).then(response => {
        context.commit("SET_CONFIG", response.config);
        return response;
      });
    },
    getReviewRequestConfig() {
      return api.get(`reviews/config`);
    },
    updateReviewRequestConfig(context, payload) {
      return api.put(`reviews/config`, payload.requestParams);
    },
    connectGoogle() {
      return api.get(`google/connect`);
    },
    getGoogleConfig() {
      return api.get(`google/config`);
    },
    getGoogleAccounts() {
      return api.get(`google/accounts`);
    },
    updateGoogleLocation(context, payload) {
      return api.put(`google/accounts`, payload.requestParams);
    },
    deleteGoogleAccount() {
      return api.delete(`google/accounts`);
    },
    getWidgetConfig() {
      return api.get(`widget/`);
    },
    updateWidgetConfig(context, payload) {
      return api.put(`widget/`, payload.requestParams);
    },
    getReviews(context, payload) {
      return api.get(`reviews/list?page=${payload.page}`);
    },
    getPublicReviews(context, payload) {
      return api.get(`widget/public/config?shop=${payload.shop}`);
    },

    getWidgetInstalled(context, payload) {
      return api.get(`widget/public/installed?widget=${payload.widget}`);
    },
    getWidgetCompatible() {
      return api.get(`widget/compatible`);
    },

    updateOnboardingFlag(context, payload) {
      return api
        .post(`shopify/onboardingflags`, payload.requestParams)
        .then(response => {
          context.commit("SET_CONFIG", response.config);
        });
    },
    getMessageLogs(context, payload) {
      return api.get(`reviews/messagelogs?page=${payload.page}`);
    },
    getScheduledMessages(context, payload) {
      return api.get(`reviews/scheduled?page=${payload.page}`);
    },
    sendReviewRequest(context, payload) {
      return api.post(`reviews/send/${payload.jobId}`);
    },
    sendTestEmail(context, payload) {
      return api.post(`reviews/testemail/send`, payload.requestParams);
    },
    getPublicReviewRequestForm(context, payload) {
      return api.get(`reviews/public/form?storeId=${payload.storeId}`);
    },
    submitFeedback(context, payload) {
      return api.post(
        `feedback/add?storeId=${payload.storeId}`,
        payload.requestParams
      );
    },
    getFeedbacks(context, payload) {
      return api.get(`feedback?page=${payload.page}`);
    },

    getUser() {
      return api.get(`shopify/user`);
    },
    getEmbedUrl(context, payload) {
      return api.get(`widget/embedurl?widget=${payload.widget}`);
    },

    getAnalytics() {
      return api.get(`reviews/analytics`);
    },
    showNotification(context, payload) {
      const event = new CustomEvent("ToastNotify", {
        detail: { text: payload.text }
      });
      window.dispatchEvent(event);
    },
    selectPlan(context, payload) {
      return api.post(`shopify/shop/plan/select`, payload.requestParams);
    },

    initAppBridge() {
      const host = new URLSearchParams(location.search).get("host");
      if (host) {
        window.appBridgeApp = true;
        console.log("app bridge intialized");
      }
    }
  }
});
